module.exports = __webpack_public_path__ + "static/media/about13.e7ce0c01.webp";